export function validateFirmName(name) {
    return name.match("^.{2,}$");
}
export function validateName(name) {
    return name.match("^.{2,}$");
}
export function validateLoginName(loginName) {
    return loginName.match("^[A-Za-zÀ-ÿ\\-\\s0-9@\\.]{3,}$");
}
export function validatePassword(password) {
    return password.match("^.{6,}$");
}
export function validateEmail(email) {
    return email.match("^[\\w\\-\\.]+@([\\w-]+\\.)+[\\w-]{2,}$") != null;
}
